import { router } from "@/route/index.js";
import useUserStore from "@/store/userStore.js";

const initialize = () => {
  router.beforeEach(async (to) => {
    let isToLogin = to.name === "login";
    if (isToLogin) {
      return true;
    }

    const userStore = useUserStore();
    const token = userStore.getToken();
    if (!token) {
      return "/login";
    }
  });

  router.onError((error) => {
    if (error.message.includes("Failed to fetch dynamically imported module")) {
      console.error("动态组件加载失败:", error);
      router.push("/404"); // 导航到 404 页面
    }
  });
};

export default initialize;
